import { validUriComponentPattern } from '../global';

export const isValidUriComponent = (component: string): boolean => {
  return !validUriComponentPattern.test(component);
};
